export const FetchKeys = {
  CARRIERS: 'CARRIERS',
  CARRIER_INTEGRATIONS: 'CARRIER_INTEGRATIONS',
  CARRIER_METHODS: 'CARRIER_METHODS',
  CARRIER_HUB_CARRIERS: 'CARRIER_HUB_CARRIERS',
  CARRIER_HUB_CARRIERS_SUMMARY: 'CARRIER_HUB_CARRIERS_SUMMARY',
  CARRIER_HUB_OPERATIONS: 'CARRIER_HUB_OPERATIONS',
  CARRIER_HUB_CREDENTIALS: 'CARRIER_HUB_CREDENTIALS',
  CARRIER_HUB_QUOTATIONS: 'CARRIER_HUB_QUOTATIONS',
  CARRIER_HUB_BINDINGS: 'CARRIER_HUB_BINDINGS',
  CARRIER_HUB_MIGRATION_PREVIEW: 'CARRIER_HUB_MIGRATION_PREVIEW',
  CARRIER_HUB_METHOD_GROUPS: 'CARRIER_HUB_METHOD_GROUPS',
  CARRIER_HUB_SHIPPING_TABLES: 'CARRIER_HUB_SHIPPING_TABLES',
  CARRIER_HUB_SHIPPING_TABLE_USAGE: 'CARRIER_HUB_SHIPPING_TABLE_USAGE',
  CARRIER_HUB_INTEGRATION_SCHEMA: 'CARRIER_HUB_INTEGRATION_SCHEMA',
  CARRIER_HUB_CONFIG_OVERRIDES: 'CARRIER_HUB_CONFIG_OVERRIDES',
  DELIVERIES: 'deliveries-view',
  DELIVERIES_PAGE: 'DELIVERIES_PAGE',
  DELIVERIES_COUNT: 'delivery-count',
  DISPATCH_RULES: 'DISPATCH_RULES',
  OFFER_AUTOMATION_RULES: 'OFFER_AUTOMATION_RULES',
  DISPATCH_RULES_SORTER: 'DISPATCH_RULES_SORTER',
  DRIVERS: 'driver-row',
  DRIVER_MANAGEMENT: 'drivers',
  ME: 'ME',
  METHODS: 'METHODS',
  NPS: 'NPS',
  ORDERS: 'ORDERS',
  ORDERS_STATS: 'ORDERS_STATS',
  // Chave PRÓPRIA, fora do prefixo `ORDERS`: o total é chaveado pelo filtro e
  // não pela página, então ele não pode ser varrido pelos `invalidateQueries`
  // que a tela dispara com prefixo `[FetchKeys.ORDERS, ...]` a cada ação de
  // linha (cancelar, despachar). Recontar 705 mil pedidos porque UM pedido
  // mudou de status é justamente o gasto que a contagem separada existe pra
  // matar.
  ORDERS_COUNT: 'ORDERS_COUNT',
  ORDER_INTEGRATIONS: 'ORDER_INTEGRATIONS',
  ORDER_PROVIDERS: 'ORDER_PROVIDERS',
  ROLES: 'ROLES',
  REPORTS: 'REPORTS',
  ANALYTICS_VOLUME_METRICS: 'ANALYTICS_VOLUME_METRICS',
  ANALYTICS_VOLUME_CHART: 'ANALYTICS_VOLUME_CHART',
  ANALYTICS_LEADTIME_CARD_SUMMARY: 'ANALYTICS_LEADTIME_CARD_SUMMARY',
  ANALYTICS_LEADTIME_CARD_CHART_TIME_OVER_TIME:
    'ANALYTICS_LEADTIME_CARD_CHART_TIME_OVER_TIME',
  ANALYTICS_LEADTIME_CARD_CHART_ORDER_SERVICE_TIME:
    'ANALYTICS_LEADTIME_CARD_CHART_ORDER_SERVICE_TIME',
  ANALYTICS_OTD_METRICS: 'ANALYTICS_OTD_METRICS',
  RESEND_RULES: 'RESEND_RULES',
  RESEND_RULES_SORTER: 'RESEND_RULES_SORTER',
  ROUTES: 'routes-view',
  ROUTABLE_ORDERS: 'routable-orders',
  SELLERS: 'SELLERS',
  SELLER_TOKENS: 'SELLER_TOKENS',
  SELLER_HEADLESS_ACCESS: 'SELLER_HEADLESS_ACCESS',
  SELLER_WEBHOOKS: 'SELLER_WEBHOOKS',
  SELLER_GROUP_THEMES: 'SELLER_GROUP_THEMES',
  SETTINGS: 'SETTINGS',
  USERS: 'USERS',
  WAREHOUSES: 'WAREHOUSES',
  MAP_ORDERS: 'MAP_ORDERS',
  BATCH_CARRIER_METHODS: 'BATCH_CARRIER_METHODS',
  ROUTES_SUGGESTIONS: 'ROUTES_SUGGESTIONS',
  QUOTATION_RULES: 'QUOTATION_RULES',
  QUOTATION_RULES_SORTER: 'QUOTATION_RULES_SORTER',
  FIND_SELLER: 'FIND_SELLER',
  RETURN: 'RETURN',
  SELLER_GROUP_CARRIER_METHOD_GROUPS: 'SELLER_GROUP_CARRIER_METHOD_GROUPS',
  EDIT_CARRIER_INTEGRATION: 'EDIT_CARRIER_INTEGRATION',
  SELLER_GROUP_ORDER_PROVIDERS: 'SELLER_GROUP_ORDER_PROVIDERS',
  QUOTATIONS: 'QUOTATIONS',
  RADIUS_TABLES: 'RADIUS_TABLES',
  CEP_TABLES: 'CEP_TABLES',
  EXTERNAL_CEP_TABLES: 'EXTERNAL_CEP_TABLES',
  INACTIVITY_RULES: 'INACTIVITY_RULES',
  INACTIVITY_RULES_SORTER: 'INACTIVITY_RULES_SORTER',
  DELIVERIES_PAYMENTS: 'DELIVERIES_PAYMENTS',
  INVOICE_TAGS: 'INVOICE_TAGS',
  TAGS: 'TAGS',
  OFFER_AUTOMATION_RULES_SORTER: 'OFFER_AUTOMATION_RULES_SORTER',
  THIRD_MODULE_LEADTIME_DATA: 'THIRD_MODULE_LEADTIME_DATA',
  SECOND_MODULE_ORDERS_DATA: 'SECOND_MODULE_ORDERS_DATA',
  SHIPPER_GROUPS: 'SHIPPER_GROUPS',
  SHIPPERS: 'SHIPPERS',
  SELLER_GROUP_OPERATION_SETTINGS: 'SELLER_GROUP_OPERATION_SETTINGS',
  SELLER_GROUP_OPERATION_SETTINGS_PROOF_OF_DELIVERY: 'SELLER_GROUP_OPERATION_SETTINGS_PROOF_OF_DELIVERY',
  SELLER_GROUP_OPERATION_SETTINGS_FAILURE_REASONS: 'SELLER_GROUP_OPERATION_SETTINGS_FAILURE_REASONS',
  SELLER_GROUP_STATUS_ALIASES: 'SELLER_GROUP_STATUS_ALIASES',
  SELLER_GROUP_DELAY_RISK_TIERS: 'SELLER_GROUP_DELAY_RISK_TIERS',
  PROMISED_DATE_RULES: 'PROMISED_DATE_RULES',
  SELLER_GROUP_INTERNAL_MARKERS: 'SELLER_GROUP_INTERNAL_MARKERS',
  SELLER_GROUP_MARKERS_LIST: 'SELLER_GROUP_MARKERS_LIST',
  SELLER_GROUP_SELLER_TAGS_LIST: 'SELLER_GROUP_SELLER_TAGS_LIST',
  SELLER_GROUP_ROUTE_TAGS_LIST: 'SELLER_GROUP_ROUTE_TAGS_LIST',
  DRIVER_TAGS_LIST: 'DRIVER_TAGS_LIST',
  DRIVER_LOCATIONS: 'DRIVER_LOCATIONS',
  DRIVER_TAGS: 'DRIVER_TAGS',
  WEBHOOK_LOGS: 'WEBHOOK_LOGS',
  CARRIER_REQUEST_LOGS: 'CARRIER_REQUEST_LOGS',
  ORDER_API_AUDIT: 'ORDER_API_AUDIT',
  OFFERED_DRIVERS: 'OFFERED_DRIVERS',
  INVALID_RULES: 'INVALID_RULES',
  LOCATION_HEALTH: 'LOCATION_HEALTH',
} as const;

export const MutationActions = {
  NEW_CARRIER_INTEGRATION: 'NEW_CARRIER_INTEGRATION',
  NEW_ORDER_INTEGRATION: 'NEW_ORDER_INTEGRATION',
  DUPLICATE_ORDER_INTEGRATION: 'DUPLICATE_ORDER_INTEGRATION',
  EDIT_ORDER_INTEGRATION: 'EDIT_ORDER_INTEGRATION',
  EDIT_CARRIER_INTEGRATION: 'EDIT_CARRIER_INTEGRATION',
} as const;
